// extracted by mini-css-extract-plugin
export default {"tagBackground":"Tag_tagBackground__gi7rF","deleteButton":"Tag_deleteButton__OtYbi"};